import { Component } from "@angular/core";

@Component({
  selector: "app-provider-services-employee",
  templateUrl: "./provider-services-employee.component.html",
  styleUrls: ["./provider-services-employee.component.scss"],
})
export class ProviderServicesEmployeeComponent {
  data: any;
  chartOptions: any;

  constructor() {
    this.data = {
      labels: ["August 01", "02", "03", "04", "05", "06", "07"],
      datasets: [
        {
          label: "Chases",
          backgroundColor: "rgba(26, 69, 112, 1)",
          borderColor: "#1E88E5",
          data: ["11", "7", "14", "9", "14", "6", "14"],
        },
        {
          label: "Pends",
          backgroundColor: "rgba(111, 188, 84, 1)",
          borderColor: "#7CB342",
          data: ["6", "8", "3", "3", "7", "3", "4"],
        },
      ],
    };

    this.chartOptions = {
      title: {
        display: true,
        text: "Over Time",
      },
      legend: {
        display: true,
        position: "top",
        fullWidth: true,
        labels: {
          fontColor: "rgb(134, 134, 134)",
          boxWidth: 11,
          left: 500,
        },
      },
      scales: {
        xAxes: [{
          ticks: {
            stepSize: 7,
            beginAtZero: true,
          },
          barThickness: 45,
          categoryPercentage: 0.1,
          barPercentage: 1,
        }],
        yAxes: [{
          ticks: {
            stepSize: 4,
            beginAtZero: true,
          },
        }],
      },
      tooltips: {
        enabled: false,
        backgroundColor: "rgba(0,0,0,0.8)",
        titleFontColor: "#fff",
        callbacks: {
          label: tooltipItem => {
            return tooltipItem.yLabel;
          },
        },
      },
      hover: {
        animationDuration: 0,
      },
      animation: {
        onComplete: ev => {
          // TODO: Write a unit test? Write an e2e test?
          const canvas = ev.chart;
          const ctx = canvas.ctx;
          ctx.textAlign = "center";
          ctx.textBaseline = "bottom";
          this.data.datasets.forEach((dataset, i) => {
            const meta = canvas.controller.getDatasetMeta(i);
            meta.data.forEach((bar, index) => {
              const num = 10;
              const data = dataset.data[index];
              ctx.fillText(data, bar._model.x, bar._model.y - num);
            });
          });
        },
      },
    };
  }
}
